module.exports = __webpack_public_path__ + "img/greenland.9101c2c.webp";